import axios from "axios";

import {
  getToken,
} from "../utils/storage";

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
  },
  timeout: 15000,
});

/*
|--------------------------------------------------------------------------
| REQUEST INTERCEPTOR
|--------------------------------------------------------------------------
*/

api.interceptors.request.use(
  (config) => {
    const token = getToken();

    console.log(
      "[API REQUEST]",
      config.method?.toUpperCase(),
      config.url
    );

    console.log(
      "[API TOKEN]",
      token
        ? `${token.substring(0, 30)}...`
        : "NO TOKEN"
    );

    /*
    |--------------------------------------------------------------------------
    | AUTHORIZATION
    |--------------------------------------------------------------------------
    */

    if (token) {
      config.headers.Authorization =
        `Bearer ${token}`;
    }

    /*
    |--------------------------------------------------------------------------
    | FORM DATA / FILE UPLOAD
    |--------------------------------------------------------------------------
    |
    | Keep application/json for all existing JSON APIs.
    |
    | When FormData is being sent, remove the JSON Content-Type so the
    | browser/Axios can automatically set:
    |
    | multipart/form-data; boundary=...
    |
    | This is required for Multer to receive req.file.
    |
    */

    if (
      config.data instanceof FormData
    ) {

      delete config.headers["Content-Type"];

    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

/*
|--------------------------------------------------------------------------
| RESPONSE INTERCEPTOR
|--------------------------------------------------------------------------
*/

api.interceptors.response.use(
  (response) => {
    console.log(
      "[API SUCCESS]",
      response.config.method?.toUpperCase(),
      response.config.url,
      response.status
    );

    return response;
  },

  (error) => {
    console.error(
      "[API ERROR]",
      error.config?.method?.toUpperCase(),
      error.config?.url
    );

    console.error(
      "[API STATUS]",
      error.response?.status
    );

    console.error(
      "[API RESPONSE]",
      error.response?.data
    );

    /*
    |--------------------------------------------------------------------------
    | TEMPORARILY DON'T AUTO LOGOUT
    |--------------------------------------------------------------------------
    */

    if (error.response?.status === 401) {
      console.warn(
        "[AUTH] 401 received"
      );
    }

    return Promise.reject(error);
  }
);

export default api;